import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyRelation_create, CompanyRelation_update, CompanyRelation_readAll, CompanyRelation_readById, CompanyRelation_readByCompanyId, CompanyRelation_delete, CompanyRelation_GetSupplierDictionary, CompanyRelation_ReadByGSTNO, CompanyRelation_ReadByCName, CompanyRelation_BulkUpsert } from 'src/app/GlobalVariables';
import { CompanyRelationCreateRequestDTO, CompanyRelationDeleteRequestDTO, CompanyRelationDTO, CompanyRelationGetSupplierDictionaryRequestDTO, CompanyRelationList, CompanyRelationReadByCompanyIdRequestDTO, CompanyRelationReadByGSTNORequestDTO, CompanyRelationReadByCNameRequestDTO, CompanyRelationReadByIdRequestDTO, CompanyRelationUpdateRequestDTO, CompanyRelationBulkUpsertRequestDTO, CompanyRelationBulkUpsertResultDTO } from './company-relation.interface';
import { GetDictionaryList } from '../common.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanyRelationService {

  constructor() { }

  http = inject(HttpClient)

  CompanyRelation_create(data: CompanyRelationCreateRequestDTO): Observable<CompanyRelationDTO> {
    return this.http.post<CompanyRelationDTO>(CompanyRelation_create, data)
  }
  CompanyRelation_update(data: CompanyRelationUpdateRequestDTO): Observable<CompanyRelationDTO> {
    return this.http.post<CompanyRelationDTO>(CompanyRelation_update, data)
  }
  CompanyRelation_readAll(): Observable<any> {
    return this.http.get<any>(CompanyRelation_readAll)
  }
  CompanyRelation_readById(data: CompanyRelationReadByIdRequestDTO): Observable<CompanyRelationDTO> {
    return this.http.post<CompanyRelationDTO>(CompanyRelation_readById, data)
  }
  CompanyRelation_readByCompanyId(data: CompanyRelationReadByCompanyIdRequestDTO): Observable<CompanyRelationList> {
    return this.http.post<CompanyRelationList>(CompanyRelation_readByCompanyId, data)
  }
  CompanyRelation_delete(data: CompanyRelationDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanyRelation_delete, data)
  }
  CompanyRelation_GetSupplierDictionary(data: CompanyRelationGetSupplierDictionaryRequestDTO): Observable<GetDictionaryList> {
    return this.http.post<GetDictionaryList>(CompanyRelation_GetSupplierDictionary, data)
  }
  CompanyRelation_ReadByGSTNO(data: CompanyRelationReadByGSTNORequestDTO): Observable<CompanyRelationList> {
    return this.http.post<CompanyRelationList>(CompanyRelation_ReadByGSTNO, data)
  }
  CompanyRelation_ReadByCName(data: CompanyRelationReadByCNameRequestDTO): Observable<CompanyRelationList> {
    return this.http.post<CompanyRelationList>(CompanyRelation_ReadByCName, data)
  }
  CompanyRelation_BulkUpsert(data: CompanyRelationBulkUpsertRequestDTO): Observable<CompanyRelationBulkUpsertResultDTO> {
    return this.http.post<CompanyRelationBulkUpsertResultDTO>(CompanyRelation_BulkUpsert, data)
  }

}
